var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFileAttachmentDucDownloadTemplate = function SvgFileAttachmentDucDownloadTemplate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.719 14.4H.059v-.8h13.66v.8ZM7.232 11.171a.4.4 0 0 1-.4-.4V.4a.4.4 0 0 1 .8 0v10.371a.4.4 0 0 1-.4.4Z",
    fill: "#187790"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.983 11.085a.53.53 0 0 1 0-.627L9.715 7c.137-.173.36-.173.496 0a.53.53 0 0 1 0 .628L7.48 11.085c-.137.174-.359.174-.496 0Z",
    fill: "#187790"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.48 11.085c-.138.174-.36.174-.497 0L4.252 7.628a.53.53 0 0 1 0-.628c.137-.173.359-.173.496 0l2.731 3.458a.53.53 0 0 1 0 .627ZM14.06 8.814c.22 0 .4.18.4.4V14.4h-.8V9.214a.4.4 0 0 1 .4-.4ZM.4 8.615c.22 0 .4.18.4.4v5.186H0V9.015c0-.22.179-.4.4-.4Z",
    fill: "#187790"
  })));
};
export default SvgFileAttachmentDucDownloadTemplate;